// TODO: package deprecated
import createPersistedState from 'vuex-persistedstate'
import checkout from './checkout'
import planQuiz from './planQuiz'
import supplements from './supplements'
import notifications from './notifications'

const dataState = createPersistedState({
  paths: ['checkout', 'planQuiz', 'supplements']
})

const plugins = process.env.MIX_APP_ENV !== 'testing' ? [dataState] : []

export default {
  modules: {
    checkout,
    planQuiz,
    supplements,
    notifications
  },
  plugins
}
